"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.FileInput = exports.FileMessage = exports.Text = exports.LoginPrompt = exports.QuickReplies = exports.Carousel = exports.fullscreen = exports.embedded = exports.Fullscreen = exports.Embedded = void 0;
require("@blueprintjs/core/lib/css/blueprint.css");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var react_intl_1 = require("react-intl");
var main_1 = __importDefault(require("./main"));
var store_1 = require("./store");
var translations_1 = require("./translations");
(0, mobx_1.configure)({ enforceActions: 'observed' });
var Embedded = function (props) { return new Wrapper(props, false); };
exports.Embedded = Embedded;
var Fullscreen = function (props) { return new Wrapper(props, true); };
exports.Fullscreen = Fullscreen;
var ExposedWebChat = /** @class */ (function (_super) {
    __extends(ExposedWebChat, _super);
    function ExposedWebChat(props, fullscreen) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            fullscreen: fullscreen,
            store: new store_1.RootStore({ fullscreen: fullscreen })
        };
        return _this;
    }
    ExposedWebChat.prototype.render = function () {
        var fullscreen = this.state.fullscreen;
        var store = this.state.store;
        var locale = store.botUILanguage;
        return (react_1.default.createElement(mobx_react_1.Provider, { store: store },
            react_1.default.createElement(react_intl_1.IntlProvider, { locale: locale, messages: translations_1.translations[locale], defaultLocale: translations_1.defaultLocale },
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(main_1.default, __assign({}, this.props))))));
    };
    return ExposedWebChat;
}(react_1.default.Component));
var Wrapper = (0, mobx_react_1.observer)(ExposedWebChat);
/**
 * @deprecated Since the way views are handled has changed, we're also exporting views in lowercase.
 * https://botpress.com/docs/developers/migrate/
 */
var _1 = require(".");
Object.defineProperty(exports, "embedded", { enumerable: true, get: function () { return _1.Embedded; } });
var _2 = require(".");
Object.defineProperty(exports, "fullscreen", { enumerable: true, get: function () { return _2.Fullscreen; } });
var renderer_1 = require("./components/messages/renderer");
Object.defineProperty(exports, "Carousel", { enumerable: true, get: function () { return renderer_1.Carousel; } });
Object.defineProperty(exports, "QuickReplies", { enumerable: true, get: function () { return renderer_1.QuickReplies; } });
Object.defineProperty(exports, "LoginPrompt", { enumerable: true, get: function () { return renderer_1.LoginPrompt; } });
Object.defineProperty(exports, "Text", { enumerable: true, get: function () { return renderer_1.Text; } });
Object.defineProperty(exports, "FileMessage", { enumerable: true, get: function () { return renderer_1.FileMessage; } });
Object.defineProperty(exports, "FileInput", { enumerable: true, get: function () { return renderer_1.FileInput; } });
Object.defineProperty(exports, "Button", { enumerable: true, get: function () { return renderer_1.Button; } });
